// extracted by mini-css-extract-plugin
export default {"small":"src-signer-app-signer-experience-next-button-module__small--lMMsr"};